import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import HistoryIcon from '@mui/icons-material/History';
import LinkIcon from '@mui/icons-material/Link';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';

const config = {
  dashboardWidth: 225,
  dateFormat: 'MM/DD/YYYY',
  dateFormatSession: 'DD-MM-YYYY',
  dateTimeFormat: 'MM/DD/YYYY hh:mmA',
  navMenu: [
    {
      key: 'startUp',
      enabled: true,
      path: '/'
    },
    {
      key: 'conduct',
      enabled: true,
      path: '/'
    },
    {
      key: 'closeOut',
      enabled: true,
      path: '/'
    },
    {
      key: 'search',
      enabled: true,
      path: '/'
    },
    {
      key: 'edc',
      enabled: true,
      path: '/'
    },
    {
      key: 'etmf',
      enabled: true,
      path: '/'
    },
    {
      key: 'reports',
      enabled: true,
      path: '/'
    },
    {
      key: 'aboutUs',
      enabled: false,
      path: '/'
    }
  ],
  tmfMenuConfig: {
    layoutDirection: 'row',
    tabsOrientation: 'vertical'
  },
  tmfMenu: [
    {
      key: 'landingPage',
      enabled: true,
      path: '/'
    },
    {
      key: 'search',
      enabled: true,
      path: '/'
    },
    {
      key: 'milestoneTracking',
      enabled: true,
      path: '/'
    },
    {
      key: 'planning',
      enabled: true,
      path: '/'
    },
    {
      key: 'documentUpload',
      enabled: true,
      path: '/'
    },
    {
      key: 'documentViewer',
      enabled: true,
      path: '/'
    },
    {
      key: 'tasks',
      enabled: true,
      path: '/'
    },
    {
      key: 'tmfModelViewer',
      enabled: true,
      path: '/'
    }
  ],
  documentViewer: {
    optionsMenu: [
      {
        icon: <AssignmentIcon />,
        id: 'addToTasks',
        name: 'Add to Tasks',
        isEnabled: true
      },
      {
        icon: <LinkIcon />,
        id: 'sendAsLink',
        name: 'Send as Link',
        isEnabled: true
      },
      {
        icon: <HistoryIcon />,
        id: 'auditTrail',
        name: 'Audit Trail',
        isEnabled: true
      },
      {
        icon: <ManageSearchIcon />,
        id: 'versionHistory',
        name: 'Version History',
        isEnabled: true
      },
      {
        icon: <AddShoppingCartIcon />,
        id: 'checkOut',
        name: 'Check Out',
        isEnabled: false
      },
      {
        icon: <DownloadIcon />,
        id: 'download',
        name: 'Download',
        isEnabled: true
      },
      {
        icon: <DeleteIcon />,
        id: 'remove',
        name: 'Delete',
        isEnabled: true
      }
    ],
    metaDataDetails: [
      {
        key: 'details',
        enabled: true,
        position: 1,
        isEditable: true
      },
      {
        key: 'qualityControl',
        enabled: true,
        position: 2,
        isEditable: true
      },
      {
        key: 'metrics',
        enabled: true,
        position: 3,
        isEditable: false
      },
      {
        key: 'productInformation',
        enabled: true,
        position: 4,
        isEditable: false
      },
      {
        key: 'referenceModels',
        enabled: true,
        position: 5,
        isEditable: false
      },
      {
        key: 'fileInfo',
        enabled: true,
        position: 6,
        isEditable: false
      },
      {
        key: 'inspectionReadiness',
        enabled: true,
        position: 7,
        isEditable: false
      }
    ]
  },
  isfBinderViewer: {
    optionsMenu: [
      // {
      //   id: 'progressToApproved',
      //   name: 'Progress to approved',
      //   isEnabled: true
      // },
      {
        id: 'sendAsLink',
        name: 'Send as link',
        isEnabled: true
      },
      // {
      //   id: 'edit',
      //   name: 'Edit',
      //   isEnabled: true
      // },
      // {
      //   id: 'checkOut',
      //   name: 'Check Out',
      //   isEnabled: true
      // },
      {
        id: 'auditTrail',
        name: 'Audit Trail',
        isEnabled: true
      },
      {
        id: 'versionHistory',
        name: 'Version History',
        isEnabled: true
      },
      {
        id: 'addNewVersion',
        name: 'Add New Version',
        isEnabled: true
      }
    ]
  }
};
export default config;
